import { Link } from "react-router-dom";
import SectionHeading from "@/components/base/SectionHeading";
import { arcs } from "@/mocks/arcs";

export default function StoryArcs() {
  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <SectionHeading
          kicker="剧情主线"
          title="斗罗大陆漫画六大主线阶段"
          desc="从双生武魂觉醒到海神成神，用六大阶段理清《斗罗大陆》漫画的完整成长脉络。"
        />
        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {arcs.map((arc) => (
            <article
              key={arc.id}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50"
            >
              <div className="relative h-44 overflow-hidden">
                <img
                  src={arc.image}
                  alt={`斗罗大陆漫画主线·${arc.title}`}
                  className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 font-heading text-sm font-bold text-background-50">
                  {arc.no}
                </span>
                <span className="absolute right-3 top-3 rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-foreground-800">
                  {arc.progress}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold text-foreground-950">{arc.title}</h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{arc.desc}</p>
                <Link
                  to="/story"
                  className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
                >
                  查看剧情进展
                  <i className="ri-arrow-right-line" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}